import { createContext, type ReactNode, useContext } from 'react';

export interface ReportScope {
  dateRange: [string, string];
  creativeType: string[];
  campaignNames: string[];
  kpi: string;
  accountIds: number[];
}

const ReportScopeContext = createContext<ReportScope | null>(null);

export function ReportScopeProvider({
  scope,
  children,
}: {
  scope: ReportScope;
  children: ReactNode;
}): ReactNode {
  return <ReportScopeContext.Provider value={scope}>{children}</ReportScopeContext.Provider>;
}

export function useReportScope(): ReportScope {
  const scope = useContext(ReportScopeContext);
  if (scope === null) throw new Error('useReportScope must be used inside a reports route');
  return scope;
}
